import axios from 'axios';
import { post } from './utils';
import { resizeAndConvertToWebp } from '../utils/imageUtils';

export async function deleteMedia(url) {
  return post('/upload/deleteFile', { url });
}

const CLIENT_ID = '50b73e2dc3f6fb5';

/**
 * Check if a file is an image
 */
function isImageFile(file) {
  if (!file) {
    console.log('isImageFile - file is null/undefined');
    return false;
  }
  if (!file.type) {
    console.log('isImageFile - file.type is null/undefined, file:', file);
    return false;
  }
  const isImage = file.type.startsWith('image/');
  console.log('isImageFile - file.type:', file.type, 'isImage:', isImage);
  return isImage;
}

export async function getUrl(key, type) {
  return post('/upload/signedUrlS3', { key, type });
}

export async function uploadFile(url, data) {
  return fetch(url, {
    method: 'PUT',
    body: data,
  }).then(() => url);
}

/**
 * Check if image is already processed (webp and within size limit)
 */
async function isImageAlreadyProcessed(file) {
  try {
    if (!isImageFile(file)) {
      return false;
    }
    
    // Check if already webp
    if (file.type !== 'image/webp') {
      return false;
    }
    
    // Check dimensions by loading image
    return new Promise((resolve) => {
      try {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const img = new Image();
            img.onload = () => {
              // If already webp and within 500x500, consider it processed
              const isProcessed = img.width <= 500 && img.height <= 500;
              console.log('isImageAlreadyProcessed - dimensions:', img.width, 'x', img.height, 'isProcessed:', isProcessed);
              resolve(isProcessed);
            };
            img.onerror = () => {
              console.log('isImageAlreadyProcessed - image load error');
              resolve(false);
            };
            img.src = e.target.result;
          } catch (error) {
            console.error('isImageAlreadyProcessed - error creating image:', error);
            resolve(false);
          }
        };
        reader.onerror = () => {
          console.log('isImageAlreadyProcessed - file read error');
          resolve(false);
        };
        reader.readAsDataURL(file);
      } catch (error) {
        console.error('isImageAlreadyProcessed - error:', error);
        resolve(false);
      }
    });
  } catch (error) {
    console.error('isImageAlreadyProcessed - outer error:', error);
    return false;
  }
}

export async function uploadMedia(data) {

  
  // Process image: resize and convert to webp if it's an image
  let fileToUpload = data;
  const isImage = isImageFile(data);
  
  if (isImage) {
    try {
      // Convert Blob to File if needed
      if (data instanceof Blob && !(data instanceof File)) {
        const fileName = data.name || 'image.webp';
        fileToUpload = new File([data], fileName, {
          type: data.type,
          lastModified: Date.now(),
        });
        console.log('uploadMedia - converted Blob to File:', fileToUpload);
      }
      
      // Only process if not already webp
      if (fileToUpload.type !== 'image/webp') {
        console.log('uploadMedia - resizing and converting to webp...');
        fileToUpload = await resizeAndConvertToWebp(fileToUpload);
        console.log('uploadMedia - processed file:', fileToUpload.name, fileToUpload.type, fileToUpload.size);
      } else {
        console.log('uploadMedia - already webp, checking size...');
        // Check if already within size limit
        const alreadyProcessed = await isImageAlreadyProcessed(fileToUpload);
        if (!alreadyProcessed) {
          console.log('uploadMedia - webp but too large, resizing...');
          fileToUpload = await resizeAndConvertToWebp(fileToUpload);
          console.log('uploadMedia - resized file:', fileToUpload.name, fileToUpload.type, fileToUpload.size);
        } else {
          console.log('uploadMedia - already processed webp, skipping...');
        }
      }
    } catch (error) {
      // Fallback to original file if processing fails
      fileToUpload = data;
    }
  } else {
    console.log('uploadMedia - not an image file, skipping processing');
  }
  
  
  const res = await getUrl(fileToUpload.name, fileToUpload.type);
  await uploadFile(res.uploadUrl, fileToUpload);

  return res.url;
}

export async function uploadMediaWithImgBB(data) {
  const form = new FormData();
  form.append('image', data);
  return fetch(`https://api.imgbb.com/1/upload?expiration=600&key=baa746f0e3729e38babc66b31a2372c3`, {
    method: 'POST',
    headers: {
      // Authorization: `Client-ID ${CLIENT_ID}`,
    },
    body: form,
  }).then((res) => res.json());
}

export async function findProductWithImage(link) {
  return fetch(`https://find-order-by-url.phamduylai.workers.dev/`, {
    method: 'POST',
    headers: {
      // Authorization: `Client-ID ${CLIENT_ID}`,
    },
    body: JSON.stringify({
      link,
    }),
  }).then((res) => {
    try {
      return res.json()
    } catch (error) {
      const text= res.text();
      return text;
    }
  });
}
export async function uploadFiles(data, onUploadProgress) {
  try {
    const res = await axios.request({
      method: 'post',
      url: `${process.env.REACT_APP_SERVER_URL}/file/uploadFiles`,
      headers: {
        'Content-Type': 'multipart/form-data',
        authorization: `Bearer ${localStorage.getItem('sessionToken')}`,
      },
      data,
      onUploadProgress: (p) => {
        onUploadProgress(Number((p.loaded / p.total) * 100).toFixed(2));
      },
    });
    return res.data;
  } catch (error) {
    return error;
  }
}

export async function uploadImages(data, onUploadProgress) {
  try {
    const images = data.get('images');
    // const resS3 = await uploadMedia(data);
    let res = null;
    
    // uploadMedia will automatically resize and convert images to webp
    if (Array.isArray(images)) {
      res = await Promise.all(images.map((e) => uploadMedia(e)));
    } else {
      const res1 = await uploadMedia(images);
      res = [res1];
    }
    // const res = await axios.request({
    //   method: 'post',
    //   url: `${process.env.REACT_APP_SERVER_URL}/file/uploadImages`,
    //   headers: {
    //     'Content-Type': 'multipart/form-data',
    //     authorization: `Bearer ${localStorage.getItem('sessionToken')}`,
    //   },
    //   data,
    //   onUploadProgress: (p) => {
    //     onUploadProgress &&
    //       onUploadProgress(Number((p.loaded / p.total) * 100).toFixed(2));
    //   },
    // });
    return res.map((e) => ({
      // ...e,
      image: e,
      previewImage: e,
    }));
  } catch (error) {
    return error;
  }
}
